/**
 * Created by lihanying on 2017/7/6.
 */
import { GETCLUBTABLELIST, GETCLUBTABLEDETAIL, GETCLUBSETTLEMENT, GETCLUBBILLRECORD } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBTABLELIST:
      return Object.assign({}, state, { tableList: action.payload })

    case GETCLUBTABLEDETAIL:
      return Object.assign({}, state, { tableDetail: action.payload })

    case GETCLUBSETTLEMENT:
      return Object.assign({}, state, { billRecord: action.payload })

    case GETCLUBBILLRECORD:
      return Object.assign({}, state, { billRecordDetail: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubTableStatus/reduce.js